import loader from './loader';

const Component = () => import('./StorefrontV2');

export { Component, loader };
